module.exports = __webpack_public_path__ + "static/media/happy_white_boy.69e9cb6b.png";